import { memo, type ReactNode } from 'react';

export interface ListFilterCardProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export const ListFilterCard = memo<ListFilterCardProps>(({ children, className = '' }) => (
  <div
    className={`box-border flex min-w-0 w-full max-w-full flex-wrap items-center gap-2 rounded-lg border border-[var(--color-rail-card-border)] bg-[var(--color-an-surface-muted)] px-2 py-1.5 ${className}`.trim()}
    data-testid="list-filter-card"
  >
    {children}
  </div>
));

ListFilterCard.displayName = 'ListFilterCard';
